// game-objects
import { ArContainer, ArSprite } from '@aceroll/core';
import { ProgressBar } from './progress-bar';

export class LoadingBar extends ArContainer {
	#progressBar = null;

	constructor() {
		super('progress-screen');

		this.#progressBar = new ProgressBar('preloader-progress_line');

		const background = ArSprite.from('preloader-progress_bar');
		background.anchor.set(0.5, 0.5);
		background.position.set(1, 0);

		this.addChild(
			background,
			this.#progressBar
		);
	}

	setProgress(progress) {
		this.#progressBar.setProgress(progress);
	}
}
